// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class WatchlistsService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    /** ******* WATCHLIST ******* **/
    // GET filtered/sorted watchlists for the watchlist list page
    getWatchlists(getParams) {
        const url = this.urlsService.WATCHLISTS.WATCHLIST_COLLECTION;
        return this.ajaxService.getDataObserveBody(url, getParams);
    }
    // GET all of a user's watchlists for the add to watchlist modal
    getAddToWatchlistMenu() {
        const url = this.urlsService.getUrl(this.urlsService.WATCHLISTS.ADD_TO_WATCHLIST_MENU);
        return this.ajaxService.getDataObserveBody(url);
    }
    postWatchlist(watchlistType, name, securityIds, uploadRecordId) {
        const postParams = {
            name,
            watchlistType,
            securityIds: JSON.stringify(securityIds),
        };
        if (uploadRecordId) {
            postParams.uploadRecordId = uploadRecordId;
        }
        const url = this.urlsService.getUrl(this.urlsService.WATCHLISTS.WATCHLIST_COLLECTION);
        return this.ajaxService.postFormEncodedDataObserveBody(url, postParams);
    }
    putWatchlist(watchlistId, securityIds, name, uploadRecordId) {
        const urlParams = { watchlistId };
        const putParams = { watchlistName: name, securityIds };
        if (uploadRecordId) {
            putParams.uploadRecordId = uploadRecordId;
        }
        const url = this.urlsService.getUrl(this.urlsService.WATCHLISTS.WATCHLIST, urlParams);
        return this.ajaxService.putJsonDataObserveBody(url, putParams);
    }
    deleteWatchlist(watchlistId) {
        const urlParams = { watchlistId };
        const url = this.urlsService.getUrl(this.urlsService.WATCHLISTS.WATCHLIST, urlParams);
        return this.ajaxService.deleteDataObserveBody(url);
    }
    /** ******* WATCHLIST INFO ******* **/
    getWatchlistInfo(watchlistIds) {
        const urlParams = { watchlistIds: watchlistIds.join(',') };
        const url = this.urlsService.getUrl(this.urlsService.WATCHLISTS.WATCHLIST_INFO, urlParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    /** ******* WATCHLIST ITEMS ******* **/
    getWatchlistItems(watchlistId) {
        // If duplicate is true then the backend will not check the users permissions on the watchlist
        const urlParams = { watchlistId };
        const url = this.urlsService.getUrl(this.urlsService.WATCHLISTS.WATCHLIST_ITEM_COLLECTION, urlParams);
        return this.ajaxService.getDataObserveBody(url);
    }
    postWatchlistItem(watchlistId, itemId, itemType) {
        const urlParams = { watchlistId };
        const postParams = { itemId, itemType };
        const url = this.urlsService.getUrl(this.urlsService.WATCHLISTS.WATCHLIST_ITEM_COLLECTION, urlParams);
        return this.ajaxService.postFormEncodedDataObserveBody(url, postParams);
    }
    deleteWatchlistItem(watchlistId, itemId, itemType) {
        const urlParams = { watchlistId, itemId, itemType };
        const url = this.urlsService.getUrl(this.urlsService.WATCHLISTS.WATCHLIST_ITEM_DELETE, urlParams);
        return this.ajaxService.deleteDataObserveBody(url);
    }
    /** ******* WATCHLIST NOTES ******* **/
    getNotes(id) {
        const url = this.urlsService.getUrl(this.urlsService.WATCHLISTS.NOTES, { watchlistId: id });
        return this.ajaxService.getDataObserveBody(url);
    }
    createNote(id, noteText) {
        const url = this.urlsService.getUrl(this.urlsService.WATCHLISTS.NOTES, { watchlistId: id });
        return this.ajaxService.postJsonDataObserveBody(url, { note_content: noteText });
    }
    updateNote(id, noteText) {
        const url = this.urlsService.getUrl(this.urlsService.WATCHLISTS.NOTES_COLLECTION, { noteId: id });
        return this.ajaxService.putDataObserveBody(url, { note_content: noteText });
    }
    deleteNote(id) {
        const url = this.urlsService.getUrl(this.urlsService.WATCHLISTS.NOTES_COLLECTION, { noteId: id });
        return this.ajaxService.deleteDataObserveBody(url);
    }
    generateWatchlistPDFReport(securityListName, dataSource, postParams) {
        const url = this.urlsService.getUrl(this.urlsService.WATCHLISTS.WATCHLIST_GENERATE_PDF_REPORT, {
            securityListName,
            dataSource,
        });
        return this.ajaxService.getDataObserveBody(url, postParams);
    }
}
WatchlistsService.ɵfac = function WatchlistsService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || WatchlistsService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
WatchlistsService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: WatchlistsService, factory: WatchlistsService.ɵfac, providedIn: 'root' });
